import * as React from 'react';

import Stories from 'stories-react';
import 'stories-react/dist/index.css';

interface StoryProps {
  type: string;
  url: string;
  duration: number;
}

interface StoryPropsList {
  stories: StoryProps[];
}

const Story: React.FC<StoryPropsList> = ({ stories }) => {
  function ImagesStories(): React.ReactElement {
    return <Stories stories={stories} />;
  }

  const listStories: React.ReactElement = ImagesStories();

  return <> {listStories}</>;
};

export default Story;
